const formatActivityType = (type) => {
  if (!type) return "—";
  const normalized = type.toLowerCase();
  const enumMap = {
    morning_punch: "Morning Punch",
    evening_punch: "Evening Punch",
    last_call: "Last Call",
    add_stockist_visit: "Stockist Visit",
    update_stockist_visit: "Update Stockist Visit",
    add_chemist_visit: "Chemist Visit",
    update_chemist_visit: "Update Chemist Visit",
    add_doctor_visit: "Doctor Visit",
    update_doctor_visit: "Update Doctor Visit",
    travel: "Travel",
    visit: "Visit",
  };
  if (enumMap[normalized]) return enumMap[normalized];
  return normalized
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
export default formatActivityType;